// import PropTypes from 'prop-types';

import FormGroup from 'components/FormGroup';
import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import { useContext } from 'react';
import Api from 'utils/api';
import moment from 'moment';

export function DoctorSummery() {
  const { currentMeeting } = useContext(GlobalContext);

  const { data: doctorMeetingSummery } = useFetchData(
    `client-survey-measures/getMedicalSummery/${currentMeeting.clientProductUuid}/64`
  );

  const thisSummary = doctorMeetingSummery?.summery;

  const fields = [
    {
      name: 'summery',
      label: 'סיכום',
      required: true,
      type: 'textarea',
      breakLine: true,
      default: thisSummary
    }
  ];

  const onSubmit = (data) => {
    data.meetingId = currentMeeting.id;
    Api.post(
      `/client-survey-measures/doctorSummery/${currentMeeting.clientProductUuid}`,
      data
    ).then(() => {
      window.location.reload();
    });
  };

  return (
    <div>
      <div>
        סיכום פגישה עם רופא
        {doctorMeetingSummery?.value && doctorMeetingSummery?.lastUpdated && (
          <span>
            {' '}
            נכתב ב־
            {moment(doctorMeetingSummery.lastUpdated).format(
              'DD.MM.YYYY HH:mm'
            )}
          </span>
        )}
      </div>
      {doctorMeetingSummery && (
        <FormGroup
          fields={fields}
          data={doctorMeetingSummery}
          onSubmit={onSubmit}
        ></FormGroup>
      )}
      {doctorMeetingSummery?.summery && (
        <span>נכתב ע"י {doctorMeetingSummery.updatedBy}</span>
      )}
    </div>
  );
}
